import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
// Backend de Mercado Pago en Vercel
const BACKEND_URL = 'https://mercadopago-her-backend.vercel.app';
// Public Key de Mercado Pago (segura para el frontend)
const MP_PUBLIC_KEY = 'APP_USR-2e5e9ad0-2e5a-4077-b86b-9ae196fe76ec';
interface CTAButtonProps {
  onClick?: () => void;
  href?: string;
  children?: React.ReactNode;
  className?: string;
}
export function CTAButton({
  onClick,
  children,
  className = ''
}: CTAButtonProps) {
  const [loading, setLoading] = useState(false);
  const [showWallet, setShowWallet] = useState(false);
  const [preferenceId, setPreferenceId] = useState<string | null>(null);
  // Cargar SDK de Mercado Pago al montar el componente
  useEffect(() => {
    if (!(window as any).MercadoPago) {
      const script = document.createElement('script');
      script.src = 'https://sdk.mercadopago.com/js/v2';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);
  // // Renderizar el Wallet Brick cuando tengamos el preference_id
  useEffect(() => {
    if (showWallet && preferenceId) {
      const mp = new (window as any).MercadoPago(MP_PUBLIC_KEY);
      mp.bricks().create('wallet', 'wallet_container', {
        initialization: {
          preferenceId: preferenceId
        },
        customization: {
          texts: {
            valueProp: 'smart_option'
          }
        },
        callbacks: {
          onReady: () => {
            console.log('✅ Wallet listo');
          },
          onError: (error: any) => {
            console.error('🚨 Mercado Pago Wallet Error:', error);
            console.error('🚨 JSON:', JSON.stringify(error, null, 2));
            alert(`Mercado Pago Error: ${JSON.stringify(error)}`);
          }
        }
      }).then(() => {
        console.log('✅ Wallet Brick renderizado');
        setLoading(false);
      }).catch((error: Error) => {
        console.error('❌ Error al renderizar Wallet Brick:', error);
        alert(`Error: ${error.message}`);
        setShowWallet(false);
        setLoading(false);
      });
    }
  }, [showWallet, preferenceId]);
  const getCookie = (name: string) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : undefined;
  };
  const generateEventId = () => {
    return `HER-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
  };
  const handleClick = async () => {
    const eventId = generateEventId();
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');

    // Si hay un onClick custom, usarlo
    if (onClick) {
      onClick();
      return;
    }
    try {
      setLoading(true);
      // Llamar al backend para crear la preferencia
      const response = await fetch(`${BACKEND_URL}/api/create-preference`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          title: 'Protocolo H.E.R. — Acceso Completo',
          quantity: 1,
          unit_price: 12000,
          external_reference: eventId,
          event_id: eventId,
          fbp,
          fbc,
          email: undefined
        })
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error ${response.status}: ${JSON.stringify(errorData)}`);
      }
      const {
        preference_id
      } = await response.json();
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout', {}, {
          eventID: eventId
        });
      }
      if (!preference_id) {
        throw new Error('El backend no devolvió preference_id');
      }
      // Mostrar el wallet con el preference_id
      setPreferenceId(preference_id);
      setShowWallet(true);
    } catch (error) {
      console.error('Error:', error);
      alert(`Error: ${(error as Error).message}`);
      setLoading(false);
    }
  };
  const handleClose = () => {
    setShowWallet(false);
    setPreferenceId(null);
    setLoading(false);
  };
  return <>
      <motion.button onClick={handleClick} disabled={loading} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`bg-[#C8A870] hover:bg-[#E8D5B0] text-[#0a0807] px-8 min-h-[56px] md:min-h-0 md:px-12 md:py-5 rounded-[3px] font-body font-semibold uppercase tracking-[0.1em] text-[15px] md:text-[16px] shadow-[0_10px_30px_rgba(0,0,0,0.45)] hover:shadow-[0_0_40px_rgba(200,168,112,0.18),0_14px_40px_rgba(0,0,0,0.5)] transition-all duration-300 w-full md:w-auto text-center ${className} ${loading ? 'opacity-70 cursor-wait' : ''}`} data-id="element-32">
        {loading ? 'Cargando...' : children || 'Acceder al Protocolo'}
      </motion.button>

      {/* Modal con Wallet Brick */}
      {showWallet && <div className="fixed inset-0 z-[9998] bg-black/80 flex items-center justify-center p-4" onClick={handleClose} data-id="element-33">
          <div className="relative bg-[#0e0c09] border border-[#C8A870]/30 rounded-lg p-8 max-w-[500px] w-full shadow-[0_20px_60px_rgba(0,0,0,0.5)]" onClick={e => e.stopPropagation()} data-id="element-34">
            {/* Botón cerrar */}
            <button onClick={handleClose} className="absolute top-4 right-4 text-[#C8A870] text-2xl hover:text-[#E8D5B0] transition-colors" aria-label="Cerrar" data-id="element-35">
              ✕
            </button>

            {/* Contenedor del Wallet Brick */}
            <div id="wallet_container" data-id="element-36" />
          </div>
        </div>}
    </>;
}